import React from "react";
import { FaBolt } from "react-icons/fa";
import "../../Styles/DeliveryPromise.css";
import { getDeliveryPromise } from "../../utils/productPresentation";

export default function DeliveryPromise({ product, className = "" }) {
  const delivery = getDeliveryPromise(product);

  return (
    <div
      className={`delivery-promise ${delivery.isPlaceholder ? "is-placeholder" : ""} ${className}`.trim()}
      aria-label={
        delivery.isPlaceholder
          ? "Delivery timing shown at checkout"
          : `Delivery in ${delivery.detail}`
      }
    >
      <span className="delivery-promise__icon" aria-hidden="true">
        <FaBolt />
      </span>
      <span className="delivery-promise__content">
        <span className="delivery-promise__label">{delivery.label}</span>
        <span className="delivery-promise__detail">{delivery.detail}</span>
      </span>
    </div>
  );
}
